import React from "react";

import styles from "./Goods.module.scss";
import { IGoods } from "../../../../models/IGoods";
import ProductCard from "../../../UI/ProductCard/ProductCard";
import { Link } from "react-router";

interface GoodsProps {
  goods: IGoods[];
}

const Goods: React.FC<GoodsProps> = ({ goods }) => {
  return (
    <div className={styles.goods}>
      {goods.map((item, index) => (
        <div className={styles.column} key={index + 1}>
          <ProductCard img={item.img} price={item.price} colors={item.colors} title={item.title} />
        </div>
      ))}
    </div>
  );
};

export default Goods;
